<template>
  <v-card class="sim-db pa-4" elevation="1">
    <div class="sim-db__title">What just happened in the database</div>
    <div v-if="!dbState" class="sim-db__empty">
      No state yet for this participant.
    </div>
    <template v-else>
      <section class="sim-db__section">
        <div class="sim-db__label">
          delivery route (where the next SMS to this participant goes)
        </div>
        <pre class="sim-db__pre">{{ routeSummary }}</pre>
      </section>
      <section class="sim-db__section">
        <div class="sim-db__label">inbound_message (latest)</div>
        <pre class="sim-db__pre">{{ pretty(dbState.lastInbound) }}</pre>
      </section>
      <section class="sim-db__section">
        <div class="sim-db__label">prompt_delivery (latest)</div>
        <pre class="sim-db__pre">{{ pretty(dbState.lastDelivery) }}</pre>
      </section>
      <section class="sim-db__section">
        <div class="sim-db__label">activity (positive action)</div>
        <pre class="sim-db__pre">{{ pretty(dbState.activitySummary) }}</pre>
      </section>
      <section class="sim-db__section">
        <div class="sim-db__label">link_click_event (recent — see "target": RESOURCES vs COURSES)</div>
        <pre class="sim-db__pre">{{ pretty(dbState.linkClicks) }}</pre>
      </section>
      <section class="sim-db__section">
        <div class="sim-db__label">chat_sms_message (Messages bridge — INBOUND/OUTBOUND/ACK)</div>
        <pre class="sim-db__pre">{{ pretty(dbState.chatMessages) }}</pre>
      </section>
    </template>
  </v-card>
</template>

<script>
export default {
  name: 'SimulatorDbPanel',
  props: {
    dbState: {
      type: Object,
      default: null,
    },
  },
  computed: {
    routeSummary() {
      if (!this.dbState) return '—'
      const route = this.dbState.deliveryRoute || 'unknown'
      const eligible = this.dbState.liveEligible ? 'yes' : 'no'
      return `route: ${route}   live-allowlisted: ${eligible}`
    },
  },
  methods: {
    pretty(value) {
      if (value === null || value === undefined) return '—'
      try {
        return JSON.stringify(value, null, 2)
      } catch (e) {
        return String(value)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.sim-db {
  &__title {
    font-weight: 600;
    margin-bottom: 12px;
  }
  &__empty {
    color: $bh-gray--2;
    font-size: 0.875rem;
  }
  &__section {
    margin-bottom: 12px;
  }
  &__label {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: $bh-gray--2;
    margin-bottom: 4px;
  }
  &__pre {
    background: $bh-blue--4;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 0.75rem;
    line-height: 1.4;
    max-height: 220px;
    overflow: auto;
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
  }
}
</style>
